// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.story-container {
  position: relative;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}
.story-content-container {
  padding-left: 24px;
  padding-right: 24px;
  padding-top: 17px;
  height: 100%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;

  text-align: left;
}

@container (min-width: 768px) {
  .story-content-container {
    padding: 0;
  }
  .story-header {
    margin-top: 17px;
  }
}

.story-header {
  width: 100%;
  margin-top: 0;
  margin-bottom: 16px;
}

.story-headline-container {
  display: flex;
}

.story-headline {
  margin-bottom: 16px;
  padding-right: 40px;

  font-size: 20px;
  font-weight: 700;
  line-height: 100%;
  color: var(--text-primary);
}

@container (min-width: 768px) {
  .story-headline {
    padding-right: 0;
  }
}

.story-datetime {
  font-size: 16px;
  font-weight: 400;
  line-height: 100%;
  color: var(--text-secondary);
}

.story-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.story-source-logo {
  flex-shrink: 0;
  /* the 36px svg has built-in padding; collapse it to the 16px text line so
     the row keeps the 16px gap below the headline */
  margin: -10px 0;
}

.story-body {
  flex: 1;
  min-height: 0;
  overflow-wrap: anywhere;

  pre {
    margin: 0px;

    white-space: pre-wrap;
    word-wrap: break-word;
    font-family: inherit;

    font-size: 16px;
    font-weight: 400;
    line-height: 100%;
    padding-bottom: 8px;
  }

  table {
    border-collapse: collapse;
  }

  th,
  td {
    border: 1px solid #999;
    padding: 6px 10px;
  }

  td {
    text-align: left;
  }

  p {
    color: var(--text-primary);
    line-height: 20px;
  }
}

.story-close-sticky {
  position: sticky;
  top: 0;
  height: 0;
  z-index: 1;
}

.story-close-button {
  position: absolute;
  right: 0;
  z-index: 1;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: none;
  cursor: pointer;
  background-color: var(--surface-primary);
  transition-property: color, background-color;
  transition-duration: 200ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

.story-close-button svg {
  width: 24px;
  height: 24px;
}

.story-close-button:hover {
  color: #4b5563;
  /* A darker gray on hover */
  background-color: #e5e7eb;
  /* A light gray background on hover */
}

.story-close-button:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
  box-shadow:
    0 0 0 2px #ffffff,
    0 0 0 4px #6366f1;
  /* white and indigo rings */
}
`, "",{"version":3,"sources":["webpack://./src/Components/News/NewsStory.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;;EAEtB,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;;EAEnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd;oDACkD;EAClD,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,uBAAuB;;EAEvB;IACE,WAAW;;IAEX,qBAAqB;IACrB,qBAAqB;IACrB,oBAAoB;;IAEpB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;;IAEE,sBAAsB;IACtB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;IAC1B,iBAAiB;EACnB;AACF;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,YAAY;EACZ,eAAe;EACf,wCAAwC;EACxC,4CAA4C;EAC5C,0BAA0B;EAC1B,wDAAwD;AAC1D;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB;;qBAEmB;EACnB,2BAA2B;AAC7B","sourcesContent":[".story-container {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  box-sizing: border-box;\n}\n.story-content-container {\n  padding-left: 24px;\n  padding-right: 24px;\n  padding-top: 17px;\n  height: 100%;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n\n  text-align: left;\n}\n\n@container (min-width: 768px) {\n  .story-content-container {\n    padding: 0;\n  }\n  .story-header {\n    margin-top: 17px;\n  }\n}\n\n.story-header {\n  width: 100%;\n  margin-top: 0;\n  margin-bottom: 16px;\n}\n\n.story-headline-container {\n  display: flex;\n}\n\n.story-headline {\n  margin-bottom: 16px;\n  padding-right: 40px;\n\n  font-size: 20px;\n  font-weight: 700;\n  line-height: 100%;\n  color: var(--text-primary);\n}\n\n@container (min-width: 768px) {\n  .story-headline {\n    padding-right: 0;\n  }\n}\n\n.story-datetime {\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 100%;\n  color: var(--text-secondary);\n}\n\n.story-meta {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.story-source-logo {\n  flex-shrink: 0;\n  /* the 36px svg has built-in padding; collapse it to the 16px text line so\n     the row keeps the 16px gap below the headline */\n  margin: -10px 0;\n}\n\n.story-body {\n  flex: 1;\n  min-height: 0;\n  overflow-wrap: anywhere;\n\n  pre {\n    margin: 0px;\n\n    white-space: pre-wrap;\n    word-wrap: break-word;\n    font-family: inherit;\n\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 100%;\n    padding-bottom: 8px;\n  }\n\n  table {\n    border-collapse: collapse;\n  }\n\n  th,\n  td {\n    border: 1px solid #999;\n    padding: 6px 10px;\n  }\n\n  td {\n    text-align: left;\n  }\n\n  p {\n    color: var(--text-primary);\n    line-height: 20px;\n  }\n}\n\n.story-close-sticky {\n  position: sticky;\n  top: 0;\n  height: 0;\n  z-index: 1;\n}\n\n.story-close-button {\n  position: absolute;\n  right: 0;\n  z-index: 1;\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  border: none;\n  cursor: pointer;\n  background-color: var(--surface-primary);\n  transition-property: color, background-color;\n  transition-duration: 200ms;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.story-close-button svg {\n  width: 24px;\n  height: 24px;\n}\n\n.story-close-button:hover {\n  color: #4b5563;\n  /* A darker gray on hover */\n  background-color: #e5e7eb;\n  /* A light gray background on hover */\n}\n\n.story-close-button:focus {\n  outline: 2px solid transparent;\n  outline-offset: 2px;\n  box-shadow:\n    0 0 0 2px #ffffff,\n    0 0 0 4px #6366f1;\n  /* white and indigo rings */\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
